import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AuthGuard } from './guards/auth.guard';

import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { RegisterComponent } from './pages/register/register.component';
import { ImgRoadmapComponent } from './sharedComponents/img-roadmap/img-roadmap.component';
import { AvatarComponent } from './featureComponents/avatar/avatar.component';
import { LevelDashboardComponent } from './pages/level-dashboard/level-dashboard.component';
import { ImgBadgeComponent } from './sharedComponents/img-badge/img-badge.component';
import { GameVideoComponent } from './games/game-video/game-video.component';
import { GameComponent } from './games/game/game.component';
import { GameMemoryComponent } from './games/game-memory/game-memory.component';
import { GameQuestionsComponent } from './games/game-questions/game-questions.component';
import { RequestInterceptor } from './interceptors/request.interceptor';
import { GameGoodBadComponent } from './games/game-good-bad/game-good-bad.component';
import { GameStressheadComponent } from './games/game-stresshead/game-stresshead.component';
import { GameHelpingThoughtsComponent } from './games/game-helping-thoughts/game-helping-thoughts.component';
import { CreateAvatarComponent } from './pages/create-avatar/create-avatar.component';
import { AudioGuard } from './guards/audio.guard';
import { CheckAvatarGuard } from './guards/check-avatar.guard';
import { GameGuard } from './guards/game.guard';
import { UserDataGuard } from './guards/user-data.guard';
import { LevelGuard } from './guards/level.guard';
import { APP_BASE_HREF } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { UserPageNotFoundComponent } from './pages/user-page-not-found/user-page-not-found.component';
import { PublicRootComponent } from './rootComponents/public-root/public-root.component';
import { UserRootComponent } from './rootComponents/user-root/user-root.component';
import { PageWrapperComponent } from './layout/page-wrapper/page-wrapper.component';
import { TextblockComponent } from './sharedComponents/textblock/textblock.component';
import { Avatar2Component } from './featureComponents/avatar2/avatar2.component';
import { ButtonBackComponent } from './sharedComponents/buttons/button-back/button-back.component';
import { PopupHeaderComponent } from './sharedComponents/popup-header/popup-header.component';
import { BtnContinueComponent } from './sharedComponents/buttons/btn-continue/btn-continue.component';
import { DiplomaComponent } from './featureComponents/diploma/diploma.component';
import { ResponsivePopupComponent } from './layout/responsive-popup/responsive-popup.component';
import { VensterBackgroundComponent } from './layout/venster-background/venster-background.component';
import { QuestionNumberComponent } from './sharedComponents/question-number/question-number.component';
import { ProgressBarComponent } from './sharedComponents/progress-bar/progress-bar.component';
import { ButtonNext2Component } from './sharedComponents/buttons/button-next2/button-next2.component';
import { ButtonNext3Component } from './sharedComponents/buttons/button-next3/button-next3.component';
import { ButtonComponent } from './sharedComponents/buttons/button/button.component';
import { LineComponent } from './sharedComponents/line/line.component';
import { PublicPageComponent } from './layout/public-page/public-page.component';
import { ButtonLiedjeComponent } from './sharedComponents/buttons/button-liedje/button-liedje.component';
import { ButtonSkipComponent } from './sharedComponents/buttons/button-skip/button-skip.component';
import { ButtonPlayComponent } from './sharedComponents/buttons/button-play/button-play.component';
import { ButtonReplayComponent } from './sharedComponents/buttons/button-replay/button-replay.component';
import { ImgOpenBaggageComponent } from './sharedComponents/img-open-baggage/img-open-baggage.component';
import { ButtonSquareComponent } from './sharedComponents/buttons/button-square/button-square.component';
import { ButtonsHelpingToughtsComponent } from './games/buttons-helping-toughts/buttons-helping-toughts.component';
import { GameClickerComponent } from './games/game-clicker/game-clicker.component';
import { GameClickerBackgroundComponent } from './games/game-clicker-background/game-clicker-background.component';
import { ButtonStartComponent } from './sharedComponents/buttons/button-start/button-start.component';
import { GameClickerClockComponent } from './games/game-clicker-clock/game-clicker-clock.component';
import { GameCompletedComponent } from './games/game-completed/game-completed.component';
import { GameLevelCompletedComponent } from './games/game-level-completed/game-level-completed.component';
import { ButtonBack2Component } from './sharedComponents/buttons/button-back2/button-back2.component';
import { GameTellerComponent } from './games/game-teller/game-teller.component';
import { ButtonGoedComponent } from './sharedComponents/buttons/button-goed/button-goed.component';
import { ButtonFoutComponent } from './sharedComponents/buttons/button-fout/button-fout.component';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        DashboardComponent,
        RegisterComponent,
        ImgOpenBaggageComponent,
        ImgRoadmapComponent,
        AvatarComponent,
        LevelDashboardComponent,
        ImgBadgeComponent,
        GameComponent,
        GameVideoComponent,
        GameMemoryComponent,
        GameQuestionsComponent,
        GameGoodBadComponent,
        GameStressheadComponent,
        GameHelpingThoughtsComponent,
        CreateAvatarComponent,
        PageNotFoundComponent,
        UserPageNotFoundComponent,
        PublicRootComponent,
        UserRootComponent,
        PageWrapperComponent,
        TextblockComponent,
        Avatar2Component,
        ButtonBackComponent,
        PopupHeaderComponent,
        BtnContinueComponent,
        DiplomaComponent,
        ResponsivePopupComponent,
        VensterBackgroundComponent,
        QuestionNumberComponent,
        ProgressBarComponent,
        ButtonNext2Component,
        ButtonNext3Component,
        ButtonComponent,
        LineComponent,
        PublicPageComponent,
        ButtonLiedjeComponent,
        ButtonPlayComponent,
        ButtonSkipComponent,
        ButtonReplayComponent,
        ButtonSquareComponent,
        ButtonsHelpingToughtsComponent,
        GameClickerComponent,
        GameClickerBackgroundComponent,
        ButtonStartComponent,
        GameClickerClockComponent,
        GameCompletedComponent,
        GameLevelCompletedComponent,
        ButtonBack2Component,
        GameTellerComponent,
        ButtonGoedComponent,
        ButtonFoutComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        InlineSVGModule,
        ReactiveFormsModule
    ],
    providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        AudioGuard,
        CheckAvatarGuard,
        LevelGuard,
        GameGuard,
        UserDataGuard
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }

